import React from 'react';

import { Link } from "react-router-dom";

function Footer() {
  return (
   <div className="container" bis_skin_checked="1">
     <footer className="footer d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top"> 
        <p className="col-md-4 mb-0">© 2025 Danker</p> 
         <ul className="nav col-md-4 justify-content-end"> 
            <li className="nav-item"><Link to="/" className="nav-link px-2 text-body-secondary" onClick={() => window.scrollTo(0, 0)}>Home</Link></li> 
            <li className="nav-item"><Link to="/bio" className="nav-link px-2 text-body-secondary">Bio</Link></li> 
            <li className="nav-item"><Link to="/editoriales" className="nav-link px-2 text-body-secondary">Editoriales</Link></li> 
            <li className="nav-item"><Link to="/#media" className="nav-link px-2 text-body-secondary">Media</Link></li>
            <li className="nav-item"><Link to="/#contacto" className="nav-link px-2 text-body-secondary">Contacto</Link></li> 
        </ul> 
    </footer>
</div>
  );
}
export default Footer; 
